import type { Values } from '../../common'

export const filterSearchOption = (column: Values[], lang) => {
  return column
    .filter((i: Values) => i.search === true)
    .map((i) => {
      const item = { type: 'input', ...i, label: lang(i.label), disabled: i.searchDisabled === true }
      if (i.labelAlias) {
        item.label = lang(i.labelAlias)
      }
      if (i.searchPlaceholder) {
        item.placeholder = lang(i.searchPlaceholder)
      } else {
        switch (item.type) {
          case 'input':
            item.placeholder = lang('请输入')
            break
          case 'select':
            item.placeholder = lang('请选择')
            break
          default:
            break
        }
      }
      if (i.searchClearable !== false) {
        item.allowClear = true
      } else {
        item.allowClear = false
      }
      if (isNaN(i.sort)) {
        item.sort === 999
      }
      return item
    })
    .sort((a, b) => a.sort - b.sort)
}

export const filterFormOption = (column: Values[], lang) => {
  return column
    .filter((i: Values) => i.display !== false)
    .map((i) => {
      if (i.allowClear !== false) {
        i.allowClear = true
      }
      if (i.clearable !== false) {
        i.allowClear = true
      } else {
        i.allowClear = false
      }
      if (i.onChange) {
        i.change = i.onChange
        delete i.onChange
      }
      return { type: 'input', ...i, label: lang(i.label) }
    })
    .sort((a, b) => a.formsolt - b.formsolt)
}

export const filterDetailOption = (column: Values[], lang) => {
  return column.map((i) => ({ type: 'text', ...i, label: lang(i.label) })).sort((a, b) => a.viewsolt - b.viewsolt)
}

export const filterPageOption = (column: Values[], lang) => {
  return column
    .filter((i: Values) => i.hide !== true)
      // .map((i) => ({ title: lang(i.label), dataIndex: i.prop, key: i.prop, ...i }))
      .map((i) => ({ title: (i.label), dataIndex: i.prop, key: i.prop, ...i }))
}
